import React from "react";

const PagePlaceholder = ({ name }) => {
  return (
    <div className="w-full h-full bg-background_2 rounded-xl flex justify-center items-center text-5xl text-secondary">
      {name}
    </div>
  );
};

export default PagePlaceholder;
